// `video.background`: live's Edit Background tool (#213).
// Live's label map (`BACKGROUND_REMOVAL`); the tool's own form builds the body.
import { VideoBackgroundQuote, VideoBackgroundRequest } from "../../../api/generated/zod";
import type { JobTypeModule } from "./contract";

export const jobType: JobTypeModule<"video.background"> = {
  type: "video.background",
  label: "Edit Background",
  source: "form",
  pair: "video.background",
  fields: () => ({}),
  request: VideoBackgroundRequest,
  quote: VideoBackgroundQuote,
};
